@if(isDisabled){
<app-loader></app-loader>
}
<form name="PostingOrderForm" (ngSubmit)="PostingOrderForm.form.valid && Save()" #PostingOrderForm="ngForm">
    <div class="card">
        <div class="card-header">
            Transfer Order
        </div>
        <div class="m-2 card-body">
            <div class="row mt-1">
                <div class="col-md-2 px-1">
                    <label>Transfer Order No. <span class="text-danger">*</span></label>
                    <input name="TransferOrderNo" class="form-control" placeholder="" [(ngModel)]="Filter.ID"
                        [disabled]="true" #PostingOrderNo="ngModel" required>
                    <div class="invalid-feedback">
                        Please Generate Transfer Order No.
                    </div>
                </div>

                <div class="col-md-2 px-1">
                    <label for="Transactiondate">Transaction Date</label>
                    <input type="date" class="form-control" [(ngModel)]="Filter.TRANSACTIONDATE" id="Transactiongdate"
                        name="Transactiongdate" [disabled]="true">
                    <div class="invalid-feedback">
                        Please select Transaction Date.
                    </div>
                </div>

                <div class="col px-1">
                    <label for="EmpcodeName" class="for-label">Employee</label>
                    <input class="form-control" [(ngModel)]="Filter.EmpcodeName" name="EmpcodeName" disabled>
                </div>
            </div>

            <div class="row mt-1">
                <div class="col-md-4 px-1">
                    <label>Branch <span class="text-danger">*</span></label>
                    <ng-select name="Branch" placeholder="Branch" [items]="BranchLoad" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Filter.BranchID" (change)="OnBranchChange()"
                        [disabled]="TransferOrderID > 0" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch.
                    </div>
                </div>
                <div class="col-md-8 px-1">
                    <label>Present Customer <span class="text-danger">*</span></label>
                    <input name="PresentCustomer" class="form-control" placeholder="" [(ngModel)]="Filter.FROM_CUSTOMER"
                        #PostingOrderNo="ngModel" [disabled]="true" required>
                    <div class="invalid-feedback">
                        Please Select Present Customer
                    </div>
                </div>
                <div class="col-md-12 px-1">
                    <label>Present Location <span class="text-danger">*</span></label>
                    <input name="PresentLocation" class="form-control" placeholder="" [(ngModel)]="Filter.FROM_SITE"
                        [disabled]="true" required>
                    <div class="invalid-feedback">
                        Please Select Present Location
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label>Employee Designation</label>
                    <input name="PresentDesignation" class="form-control" placeholder=""
                        [(ngModel)]="Filter.pdesignation" [disabled]="true">
                </div>

                <div class="col-md-4 px-1">
                    <label>Duty</label>
                    <input name="PresentDuty" class="form-control" placeholder="" [(ngModel)]="Filter.pduty"
                        [disabled]="true">
                </div>

                <div class="col-md-4 px-1">
                    <label>Shift</label>
                    <input name="PresentShift" class="form-control" placeholder="" [(ngModel)]="Filter.pshift"
                        [disabled]="true">
                </div>

                <div class="col-md-6 px-1">
                    <label>Customer <span class="text-danger">*</span></label>
                    <ng-select name="toCustomer" placeholder="Transfer To Customer" [items]="CustomerLoad"
                        bindLabel="ClientGroupName" bindValue="ClientGroupMasterID" [(ngModel)]="Filter.TO_CUSTOMERID"
                        (change)="ComboLoad('Site')" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Transfer To Customer.
                    </div>
                </div>

                <div class="col-md-6 px-1">
                    <label>Location <span class="text-danger">*</span></label>
                    <ng-select name="Location" placeholder="Transfer To Location" [items]="LocationLoad"
                        bindLabel="SiteName" bindValue="SiteMasterID"
                        (change)="ComboLoad('Designation'); LoadEmployeeDesignation();" [(ngModel)]="Filter.TO_SITEID"
                        required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Transfer To Location.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Employee Designation <span class="text-danger">*</span></label>
                    <ng-select name="EmployeeDesignation" placeholder="Designation" [items]="EmployeeDesignationLoad"
                        (change)="ComboLoad('Duty');" bindLabel="DesignationName" bindValue="DesignationMasterID"
                        [(ngModel)]="Filter.DESIGNATIONID" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Employee Designation.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Duty <span class="text-danger">*</span></label>
                    <ng-select name="duty" placeholder="Duty" [items]="Duty" bindLabel="DutyName"
                        bindValue="DutyMasterID" (change)="ComboLoad('ShiftLoadBasedOnDesignationDuty');"
                        [(ngModel)]="Filter.DUTYID" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Duty.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Shift <span class="text-danger">*</span></label>
                    <ng-select name="shift" placeholder="Shift" [items]="Shift" bindLabel="ShiftTitle"
                        bindValue="ShiftMasterID" [(ngModel)]="Filter.SHIFTID" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Shift.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Reason Of Transfer <span class="text-danger">*</span></label>
                    <ng-select name="ReseaonOfTransfer" placeholder="Reason" [items]="ReasonOfTransferLoad"
                        bindLabel="ReasonName" bindValue="ReasonMasterID" [(ngModel)]="Filter.REASONID" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Reason Of Transfer.
                    </div>
                </div>


                <div class="col-md-4 px-1">
                    <label>Remarks <span class="text-danger">*</span></label>
                    <input name="Remarks" class="form-control" placeholder="Remarks" [(ngModel)]="Filter.REMARKS"
                        #Remarks="ngModel" required>
                    <div class="invalid-feedback">
                        Please Insert Remarks
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label for="Effectivedate" class="for-label">Transfer Date</label>
                    <input type="date" [(ngModel)]="Filter.FROMDATE" class="form-control" id="Transferdate"
                        name="Transferdate">
                    <div class="invalid-feedback">
                        Please select Transfer Date.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="cancel()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>
                        <button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="isDisabled">
                            <i class="bi bi-save2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled ? (TransferOrderID > 0 ? 'Update' : 'Save'):'Loading...'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>